/**
 * BAZÍLIO CONSÓRCIOS — data layer das 3 personas (consultores).
 * Bios paráfrase baseadas nos perfis Instagram públicos do trio Bazilio.
 */

import type { VerticalKey } from "./verticais";

export interface Persona {
  slug: string;
  fullName: string;
  role: string;
  tagline: string;
  bio: string;
  instagramUrl: string;
  instagramHandle: string;
  whatsappNumber: string; // E.164 sem "+"
  whatsappDisplay: string;
  photoAvatar: string;
  photoAvatarLarge?: string;
  specialties: VerticalKey[];
  primaryVertical: VerticalKey;
  yearsExperience: number;
  metricLabel: string;
  metricValue: string;
}

export const PERSONAS: Persona[] = [
  {
    slug: "camila",
    fullName: "Camila Bazilio",
    role: "Especialista em consórcio de imóveis e veículos",
    tagline: "5 anos em consórcios de imóveis e veículos.",
    bio: "Especialista em consórcio há mais de 5 anos, atua nas verticais de imóveis, automóveis, veículos pesados e investimentos. Atendimento consultivo focado em montar uma estratégia segura para cada perfil.",
    instagramUrl: "https://instagram.com/camilabazilioconsorcio",
    instagramHandle: "@camilabazilioconsorcio",
    whatsappNumber: "5531987292967",
    whatsappDisplay: "(31) 98729-2967",
    photoAvatar: "/img/personas/camila-avatar.jpg",
    specialties: ["imoveis", "veiculos", "pesados", "servicos"],
    primaryVertical: "imoveis",
    yearsExperience: 5,
    metricLabel: "anos de experiência",
    metricValue: "5+",
  },
  {
    slug: "lucas",
    fullName: "Lucas Bazilio",
    role: "Consultor de consórcios e cartas contempladas",
    tagline: "Veículos, imóveis e cartas contempladas.",
    bio: "Consultor de consórcios com foco em veículos, imóveis e pesados. Trabalha com cotas novas e cartas contempladas, uma alternativa para quem quer reduzir o tempo de espera e negociar com mais força.",
    instagramUrl: "https://instagram.com/lucasbazilioconsultoria",
    instagramHandle: "@lucasbazilioconsultoria",
    whatsappNumber: "5531987292967",
    whatsappDisplay: "(31) 98729-2967",
    photoAvatar: "/img/personas/lucas-avatar.jpg",
    specialties: ["veiculos", "imoveis", "pesados", "motos"],
    primaryVertical: "veiculos",
    yearsExperience: 4,
    metricLabel: "verticais atendidas",
    metricValue: "4",
  },
  {
    slug: "liliane",
    fullName: "Liliane Bazilio",
    role: "Especialista em consórcio e investimentos",
    tagline: "8 anos com foco em patrimônio.",
    bio: "Especialista em consórcios há mais de 8 anos, com foco em carros, imóveis e planejamento patrimonial. Orienta cada cliente a usar o consórcio com visão de longo prazo, sem comprometer o caixa.",
    instagramUrl: "https://instagram.com/liliane_bazilio_consorcio",
    instagramHandle: "@liliane_bazilio_consorcio",
    whatsappNumber: "5531987292967",
    whatsappDisplay: "(31) 98729-2967",
    photoAvatar: "/img/personas/liliane-avatar.jpg",
    specialties: ["veiculos", "imoveis", "agro", "servicos"],
    primaryVertical: "imoveis",
    yearsExperience: 8,
    metricLabel: "anos de experiência",
    metricValue: "8+",
  },
];

export const PERSONAS_BY_SLUG: Record<string, Persona> = Object.fromEntries(
  PERSONAS.map(p => [p.slug, p])
);

/**
 * Retorna a persona que melhor atende uma vertical (para destaque em ALP).
 * Prefere quem tem essa vertical como primaryVertical, senão primeira que a lista nas specialties.
 */
export function getPrimaryPersonaFor(vertical: VerticalKey): Persona {
  const primary = PERSONAS.find(p => p.primaryVertical === vertical);
  if (primary) return primary;
  const spec = PERSONAS.find(p => p.specialties.includes(vertical));
  return spec ?? PERSONAS[0];
}
